"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _capitalize = _interopRequireDefault(require("lodash/capitalize"));
var _EDSContext = require("./../EDSContext/EDSContext");
var _styles = _interopRequireDefault(require("../styles"));
var _material = require("@mui/material");
var _MobileStepperCounter = _interopRequireDefault(require("./MobileStepperCounter"));
var _constants = require("./internal/constants");
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "activeStep", "steps", "StepCounterContent", "position", "children", "edsContext"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.grey[200],
      height: _tokens.sizingXxLarge1,
      padding: "0 " + _tokens.spacing50
    },
    // StepCounter styles when position is bottom
    stepCounterBottom: {
      position: 'fixed',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      left: '50%',
      bottom: _tokens.spacing30,
      zIndex: theme.zIndex.mobileStepper + 1 // MUI defined z-index + 1 to show on top of the MuiMobileStepper
    },
    // StepCounter styles when position is static
    stepCounterStatic: {
      position: 'relative',
      textAlign: 'center',
      top: 40
    }
  };
};

/**
 * Mobile step progress
 */
var MobileStepper = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)(''),
    label = _useState[0],
    setLabel = _useState[1];
  var localRef = ref || (0, _react.useRef)(); //eslint-disable-line react-hooks/rules-of-hooks
  var classes = props.classes,
    activeStep = props.activeStep,
    steps = props.steps,
    StepCounterContent = props.StepCounterContent,
    position = props.position,
    children = props.children,
    edsContext = props.edsContext,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    root: classes.root
  };
  var mobileStepperCounterClassName = (0, _classnames.default)(classes["stepCounter" + (0, _capitalize.default)(position)]);

  // This effect sets the div with current step content with error message if there is one.
  (0, _react.useEffect)(function () {
    var mobileStepLabel = localRef.current.querySelector("." + _constants.MOBILE_STEPPER_LABEL_CLASSNAME);
    setLabel(props.activeStep + 1 > steps ? edsContext.formatMessage('component.MobileStepper.allStepsCompleted') : edsContext.formatMessage('component.MobileStepper.a11yLabel', {
      label: mobileStepLabel && mobileStepLabel.textContent
    }));
  }, [props.activeStep, steps, edsContext, localRef]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: localRef
  }, children, StepCounterContent ? /*#__PURE__*/_react.default.createElement("div", {
    className: mobileStepperCounterClassName
  }, StepCounterContent) : /*#__PURE__*/_react.default.createElement("div", {
    className: mobileStepperCounterClassName,
    "aria-atomic": "false",
    "aria-live": "assertive",
    "aria-label": label
  }, /*#__PURE__*/_react.default.createElement(_MobileStepperCounter.default, {
    activeStep: activeStep,
    steps: steps,
    position: position
  })), /*#__PURE__*/_react.default.createElement(_material.MobileStepper, (0, _extends2.default)({
    steps: steps,
    activeStep: activeStep,
    position: position,
    classes: classOverrides,
    variant: null
  }, rest)));
});
MobileStepper.muiName = 'MobileStepper';
MobileStepper.displayName = 'MobileStepper';
MobileStepper.propTypes = {
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes.default.number,
  /**
   * A back button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  backButton: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The children will be rendered before the `<MobileStepperCounter>` and the bottom control bar.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object, _propTypes.default.node]),
  /**
   * A next button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  nextButton: _propTypes.default.node,
  /**
   * Set the positioning type.
   */
  position: _propTypes.default.oneOf(['bottom', 'static']),
  /**
   * The total steps.
   */
  steps: _propTypes.default.number.isRequired,
  /**
   * Sent in a custom step counter.
   */
  StepCounterContent: _propTypes.default.node,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object
};

// default property values
MobileStepper.defaultProps = {
  activeStep: 0,
  position: 'bottom'
};
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(MobileStepper));